$(document).ready(function () {
	initializeNewSystem();
});

function initializeNewSystem() {
	const NEW_API_BASE = "https://points.lapondo.de/api/customer";
	const customerEmail = getCustomerEmail();

	// Reuse existing modal but with new handlers
	const modal = document.getElementById("myModalss");
	const newRedeemBtn = document.getElementById("new-redeembtn");

	// Initialize: Load points and active codes
	if (customerEmail) {
		loadPointBalance(customerEmail);
		loadActiveCodes(customerEmail);
	}

	// New redeem button (opens same modal)
	if (newRedeemBtn) {
		newRedeemBtn.onclick = function () {
			modal.style.display = "block";
			if (customerEmail) loadPointBalance(customerEmail);
		};
	}

	// Points input handler
	const pointsInput = document.getElementById("new-points-to-use");
	if (pointsInput) {
		pointsInput.addEventListener("input", updateDiscountPreview);
	}

	// Create discount button
	const createBtn = document.getElementById("new-create-discount-btn");
	if (createBtn) {
		createBtn.addEventListener("click", handleCreateDiscount);
	}

	// The existing close handler will work for both systems
}

function getCustomerEmail() {
	// Try multiple sources for email
	if (typeof __st !== "undefined" && __st.customer && __st.customer.email) {
		return __st.customer.email;
	}

	const emailInput =
		document.getElementById("new-email") || document.getElementById("email");
	return emailInput ? emailInput.value : null;
}

function loadPointBalance(email) {
	const NEW_API_BASE = "https://points.lapondo.de/api/customer";

	fetch(`${NEW_API_BASE}/points/balance?email=${encodeURIComponent(email)}`)
		.then((response) => response.json())
		.then((data) => {
			if (data.success) {
				const points = data.data.points;

				// Update display elements
				const pointsDisplay = document.getElementById("new-current-points");
				const potentialDisplay = document.getElementById(
					"new-potential-discount-info",
				);

				if (pointsDisplay) {
					pointsDisplay.textContent = `Verfügbare Punkte: ${points.type1.available}`;
				}

				if (potentialDisplay) {
					potentialDisplay.textContent = `Möglicher Rabatt: ${points.type1.available}€`;
				}

				// Update input max value
				const pointsInput = document.getElementById("new-points-to-use");
				if (pointsInput) {
					pointsInput.max = points.type1.available;
				}

				// Show points info in cart
				const pointsInfo = document.getElementById("new-points-info");
				if (pointsInfo) {
					pointsInfo.style.display = "block";
					const balanceDiv = document.getElementById("new-points-balance");
					//if (balanceDiv) {
					//	balanceDiv.textContent = `Verfügbar: ${points.type1.available} Punkte`;
					//}
				}

				console.log("✅ Point balance loaded:", points.type1.available);
			} else {
				console.error("❌ Failed to load point balance:", data.error);
				showError("Fehler beim Laden der Punktebilanz: " + data.error);
			}
		})
		.catch((error) => {
			console.error("❌ Network error loading points:", error);
			showError("Netzwerkfehler beim Laden der Punkte");
		});
}

function loadActiveCodes(email) {
	const NEW_API_BASE = "https://points.lapondo.de/api/customer";

	fetch(`${NEW_API_BASE}/discounts/active?email=${encodeURIComponent(email)}`)
		.then((response) => response.json())
		.then((data) => {
			if (data.success && data.data.length > 0) {
				displayActiveCodes(data.data);
			}
		})
		.catch((error) => {
			console.error("❌ Error loading active codes:", error);
		});
}

function displayActiveCodes(codes) {
	const container = document.getElementById("new-active-codes-container");
	const header = document.getElementById("new-chead");

	if (codes.length === 0) return;

	const codeHTML = codes
		.map(
			(code) => `
    <div style="background: #e8f5e8; padding: 10px; margin: 5px 0; border-radius: 5px; border-left: 4px solid #28a745;">
      <strong>Code: ${code.code}</strong><br>
      <small>Wert: ${code.value}€ | Gültig bis: ${new Date(code.endsAt).toLocaleDateString("de-DE")}</small>
    </div>
  `,
		)
		.join("");

	if (container) {
		container.innerHTML = codeHTML;
		if (header) header.style.display = "block";
	}
}

function updateDiscountPreview() {
	const pointsToUse =
		parseInt(document.getElementById("new-points-to-use").value) || 0;

	const previewDiv = document.getElementById("new-discount-preview");
	if (previewDiv) {
		previewDiv.textContent = `Rabattvorschau: ${pointsToUse}€`;
	}
}

function handleCreateDiscount() {
	const email = document.getElementById("new-email").value;
	const pointsToUse =
		parseInt(document.getElementById("new-points-to-use").value) || 0;
	const termsChecked = document.getElementById("new-terms-checkbox").checked;

	// Validation
	if (!email) {
		showError("Email ist erforderlich");
		return;
	}

	if (pointsToUse === 0) {
		showError("Bitte mindestens einen Punkt auswählen");
		return;
	}

	if (!termsChecked) {
		showError("Bitte bestätigen Sie die Bedingungen");
		return;
	}

	// Show loading state
	showButton("new-wait-btn");

	// Create discount (simplified - only type1Points)
	const NEW_API_BASE = "https://points.lapondo.de/api/customer";

	fetch(`${NEW_API_BASE}/discounts/create`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify({
			email: email,
			type1Points: pointsToUse, // Only type1Points
			type2Points: 0, // Always 0
			discountType: "fixed_amount",
			customerSpecific: true,
			// expirationHours: 168, // 1 week
			usageLimit: 1,
		}),
	})
		.then((response) => response.json())
		.then((data) => {
			if (data.success) {
				// Success!
				const discountCode = data.data.discountCode.code;
				document.getElementById("new-discount-code").textContent = discountCode;
				showButton("new-success-btn");

				// Reload points and active codes
				loadPointBalance(email);
				loadActiveCodes(email);

				// Auto-apply discount to cart after 2 seconds
				setTimeout(() => {
					applyDiscountToCart(discountCode);
				}, 2000);

				console.log("✅ Discount created successfully:", discountCode);
			} else {
				showError("Fehler: " + data.error);
				showButton("new-error-btn");
			}
		})
		.catch((error) => {
			console.error("❌ Error creating discount:", error);
			showError("Netzwerkfehler beim Erstellen des Rabattcodes");
			showButton("new-error-btn");
		});
}

function applyDiscountToCart(discountCode) {
	// Redirect to checkout with discount code applied
	window.location.href = `/checkout?discount=${discountCode}`;
}

function showButton(buttonId) {
	// Hide all new system buttons first
	[
		"new-create-discount-btn",
		"new-wait-btn",
		"new-success-btn",
		"new-error-btn",
	].forEach((id) => {
		const btn = document.getElementById(id);
		if (btn) btn.style.display = "none";
	});

	// Show target button
	const targetBtn = document.getElementById(buttonId);
	if (targetBtn) targetBtn.style.display = "block";
}

function showError(message) {
	const errorDiv = document.getElementById("new-error-message");
	if (errorDiv) {
		errorDiv.textContent = message;
		errorDiv.style.display = "block";
	}
	console.error("❌", message);
}

// Refresh function for cart updates (similar to existing system)
document.documentElement.addEventListener("cart:refresh", function () {
	const customerEmail = getCustomerEmail();
	if (customerEmail) {
		loadPointBalance(customerEmail);
		loadActiveCodes(customerEmail);
	}
});
